import React from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled, { css } from 'styled-components';
import { _ as _taggedTemplateLiteral, a as _objectWithoutProperties } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import './_arrayReduce-35053fa6.js';
import './isArray-a3f14da2.js';
import './_Map-9acd9da3.js';
import './get-f58f8821.js';
import './join-15b17329.js';
import { g as getSpacesAsCss } from './getSpacesAsCSS-2c03c4c1.js';
import './_hasUnicode-6e5e26e7.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  margin: ", ";\n\n  // Use of a circle in the radio when it's checked.\n  &:after {\n    content: ' ';\n    display: block;\n    visibility: hidden;\n    background-color: ", ";\n    width: calc(", " / 2);\n    height: calc(", " / 2);\n    border-radius: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var borders = css(["border-radius:", ";border:", " solid ", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.components.radio.radioButton.borders.radius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.components.radio.radioButton.borders.width;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.components.radio.radioButton.colors.border;
});
var sizes = css(["height:", ";width:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.components.radio.radioButton.sizes.heights;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.components.radio.radioButton.sizes.widths;
});
var RadioButton = styled.span(_templateObject(), borders, sizes, function (_ref6) {
  var theme = _ref6.theme;
  return getSpacesAsCss(theme.components.radio.radioButton.spaces);
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.components.radio.radioButton.colors.backgroundChecked;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.components.radio.radioButton.sizes.widths;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.components.radio.radioButton.sizes.heights;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.components.radio.radioButton.borders.radius;
});

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  opacity: 0;\n  cursor: pointer;\n  margin: 0;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var HiddenInputRadio = styled.input(_templateObject$1());

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n\n  // Modifications of the color background of the radio :\n  &:hover ", " + ", " {\n    border: ", " solid\n      ", ";\n\n    &:after {\n      visibility: visible;\n      background-color: ", ";\n    }\n  }\n\n  ", ":checked + ", " {\n    &:after {\n      visibility: visible;\n    }\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var RadioContainer = styled('div')(_templateObject$2(), HiddenInputRadio, RadioButton, function (_ref) {
  var theme = _ref.theme;
  return theme.components.radio.radioButton.borders.width;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.components.radio.radioButton.colors.borderHover;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.components.radio.radioButton.colors.backgroundHover;
}, HiddenInputRadio, RadioButton);

function _templateObject$3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * A radio button.
 *
 */

var Radio = function Radio(_ref) {
  var checked = _ref.checked,
      id = _ref.id,
      name = _ref.name,
      onChange = _ref.onChange,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ["checked", "id", "name", "onChange", "value"]);

  var handleToggleChecked = function handleToggleChecked(event) {
    onChange && onChange(event);
  };

  return React.createElement(RadioContainer, rest, React.createElement(HiddenInputRadio, {
    id: id,
    checked: checked === value,
    name: name,
    onChange: handleToggleChecked,
    type: "radio",
    value: value
  }), React.createElement(RadioButton, null));
};

Radio.defaultProps = {
  checked: false,
  onChange: null
};
Radio.propTypes = {
  /**
   * Should equals the value if you want it to be checked.
   */
  checked: PropTypes.string,

  /**
   * The id of the current element.
   */
  id: PropTypes.string.isRequired,

  /**
   * The name attribute is used to reference form data after a form is submitted.
   * Numerous radio with the same name value will be in the same group.
   */
  name: PropTypes.string.isRequired,

  /**
   * Gets called when the value of the radio changes.
   *
   * @param {SyntheticEvent} event The react `SyntheticEvent`
   */
  onChange: PropTypes.func,

  /**
   * The value attribute of the radio. This attribute has meaning when submitting a form.
   */
  value: PropTypes.string.isRequired
};
/** @component */

var index = styled(Radio)(_templateObject$3());

export default index;
